import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, unref as _unref, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-709e764c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderFormMulti_Wrap" }
const _hoisted_2 = { class: "OrderFormMulti_Select" }
const _hoisted_3 = { class: "OrderFormMulti_Select_Flex" }
const _hoisted_4 = { class: "OrderFormMulti_SelectContainer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "OrderFormMulti_Title" }, "引継ぎ項目：", -1))
const _hoisted_6 = { class: "OrderFormMulti_SelectArea" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "OrderFormMulti_Select_Flex" }
const _hoisted_9 = { class: "OrderFormMulti_Download" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "loading"
}
const _hoisted_12 = {
  key: 0,
  class: "OrderFormMulti_Download_Select"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "通常版", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "OrderFormMulti_Download_Option input_disabled"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "通常版", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "簡易版", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 3,
  class: "OrderFormMulti_Download_Option input_disabled"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "簡易版", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "loading"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "アップロード", -1))
const _hoisted_26 = { class: "OrderFormMulti_MainArea" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderFormMulti_Table_Meisai OrderFormMulti_Table_Sticky_TH" }, [
  /*#__PURE__*/_createTextVNode(" 明細"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("No ")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderFormMulti_Table_SyotenInfo" }, "取次情報", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderFormMulti_Table_Jyoken" }, [
  /*#__PURE__*/_createTextVNode(" 書店コード / 番線"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("書店名 ")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "OrderFormMulti_Table_SyotenInfo",
  style: {"min-width":"170px"}
}, [
  /*#__PURE__*/_createTextVNode(" コード検索"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("在庫 / 断裁 ")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderFormMulti_Table_SyosiInfo" }, [
  /*#__PURE__*/_createTextVNode(" 本体価格 / 依頼者"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("書名 ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, [
  /*#__PURE__*/_createTextVNode("保留"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("設定")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderFormMulti_Table_JuchuInfo" }, [
  /*#__PURE__*/_createTextVNode(" 使用可能数"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("受注数 ")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderFormMulti_Table_Num" }, [
  /*#__PURE__*/_createTextVNode("受注保留"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("品切保留")
], -1))
const _hoisted_35 = { class: "OrderFormMulti_Table_Tanzaku" }
const _hoisted_36 = {
  key: 1,
  class: "OrderFormMulti_Button disabled_btn",
  style: {"margin-left":"5px"},
  disabled: ""
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderFormMulti_Table_Delete" }, "削除", -1))
const _hoisted_38 = { class: "OrderFormMulti_Table_Meisai OrderFormMulti_Table_ValignMid OrderFormMulti_Table_Sticky_TD" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["value", "onChange"]
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 0,
  class: "OrderFormMulti_Error"
}
const _hoisted_44 = ["onUpdate:modelValue", "onDblclick", "onFocus"]
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = {
  key: 0,
  class: "OrderFormMulti_Error",
  style: {"text-align":"left"}
}
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = ["onUpdate:modelValue", "onDblclick", "onFocus"]
const _hoisted_50 = { style: {"font-size":"12px"} }
const _hoisted_51 = { class: "OrderFormMulti_Table_SyosiInfo OrderFormMulti_Table_ValignTop" }
const _hoisted_52 = { style: {"display":"flex"} }
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = ["value"]
const _hoisted_56 = {
  key: 0,
  class: "OrderFormMulti_Error",
  style: {"text-align":"left"}
}
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = { class: "OrderFormMulti_Table_JuchuInfo OrderFormMulti_Table_ValignMid" }
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = ["onUpdate:modelValue", "onFocus", "onChange", "onBlur"]
const _hoisted_62 = {
  key: 0,
  class: "OrderFormMulti_Error",
  style: {"text-align":"left"}
}
const _hoisted_63 = { class: "OrderFormMulti_Table_Num OrderFormMulti_Table_ValignMid" }
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = { class: "OrderFormMulti_Table_Tanzaku OrderFormMulti_Table_ValignMid" }
const _hoisted_67 = { style: {"display":"flex"} }
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OrderFormMulti_Error" }, "※「短冊メモ」は全角16文字以内で入力してください", -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "OrderFormMulti_ButtonArea" }
const _hoisted_75 = { class: "total_number" }

import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import InputText from "@/components/atoms/Input/InputText.vue";
import ModalMultiTanzaku from "../components/modal/ModalMultiTanzaku.vue";
// import ModalMultiTorioki from "../components/modal/ModaLMultiTorioki.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import ModalShopList from "@/components/modal/ModalShopList.vue";
import ModalSyosiList from "@/components/modal/ModalSyosiList.vue";
import { Notyf } from "notyf";
import { useStore } from "vuex";
import { ZaikoData } from "@/types/zaiko";
import axios from "axios";
import { directive as vClickOutside } from "click-outside-vue3";
import * as xlsx from "xlsx";
import common from "../common";
import BadgeHold from "@/components/atoms/Badge/BadgeHold.vue";
import SelectBarSingle from "@/components/molecules/selectBarSingle.vue";
import ModalCartAlert from "@/components/modal/ModalCartAlert.vue";

export type MultiOrderList = typeof multiOrder_list.value[0];

// 表示データ初期値をJSONとして保持（比較用）
type HikitsugiList = typeof hikitsugi_list.value[0];

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFormMulti',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props) {

const notyf = new Notyf();
const store = useStore();



// 変数定義----------------------------------
//検索項目のリスト取得
//営業担当者(依頼者)⇒ログインユーザーが営業担当者だった場合初期表示する
const salesList = ref(store.getters["constant/getSalesList"]);
const initSalesCd = ref(null as number | null); // 初期値に持たせるセールスコード
// ログイン中ユーザーが営業担当者の場合初期表示用データに該当データを格納
if (store.getters["constant/getIsSales"]) {
  initSalesCd.value = salesList.value[1].salesCd;
}

//ぱんくずヘッダー
const currentPathList = [
  { name: "受注入力" },
  { name: "マルチ受注" },
  { name: "マルチ入力" },
];

const userInfo = store.getters["login/getUserData"];
// 表示データ
const multiOrder_list = ref([
  {
    // 保存時に引数で渡すデータ
    hanmotoCd: userInfo.hanmotoCd,
    userId: userInfo.userId as number | null,
    janCd: "",
    quantity: "",
    toritugiCd: "",
    toritugisyotenCd: "",
    bansen: "",
    salesName: initSalesCd.value,
    tanzaku: "",
    isHold: false,
    // 画面表示のみのデータ
    meisaiNo: 1,
    toritugisyotenMei: "",
    syosiCd: "",
    syuppanSyosiCd: "",
    hontaiPrice: null as number | null,
    syosiMei: "",
    availableAmount: null as number | null, // 使用可能数
    holdSum: null as number | null, // 受注保留数
    shinagireHoryuSuu: null as number | null, // 品切保留数
    tanzakuFlg: false, // 短冊データの有無
    selectFlg: false,
    searchSyosiCord: "",
    zsId: "",
    zsName: "",
    zsNameDisplay: "",
    cutting: "",
  },
]);
const initialData = ref(JSON.stringify(multiOrder_list.value));

// 項目入力関連------------------------------------------------
// 取次
const inputToritugi = (event: any, orderIndex: number) => {
  // ターゲットデータの取次情報を更新
  multiOrder_list.value[orderIndex].toritugiCd = event.target.value;
  // ターゲットデータの書店情報をリセット
  multiOrder_list.value[orderIndex].toritugisyotenMei = "";
  multiOrder_list.value[orderIndex].toritugisyotenCd = "";
  multiOrder_list.value[orderIndex].bansen = "";
};

// 受注数入力
let holdQuantity = "";
const focusQuantity = (e: any, index: number) => {
  holdQuantity = e.target.value;
  multiOrder_list.value[index].quantity = "";
};
const validateQuantity = (e: any, index: number) => {
  //符号無し整数を判定
  if (!e.target.value.match(/^[0-9]+$/)) {
    multiOrder_list.value[index].quantity = "";
  }
};
const blurQuantity = (e: any, index: number) => {
  if (e.target.value === "") {
    multiOrder_list.value[index].quantity = holdQuantity;
  }
  holdQuantity = "";
};

// 短冊
// バリデーション
const isValidTanzaku = computed(() => (tanzaku: string) => {
  if (tanzaku.length && (tanzaku.length > 16 || !isZenkaku(tanzaku))) {
    return true;
  } else {
    return false;
  }
});
const isZenkaku = (value: string) => {
  // eslint-disable-next-line no-control-regex
  const pattern = /^[^\x01-\x7E\uFF61-\uFF9F]+$/;
  return value.match(pattern);
};
// 一括編集
// 編集ボタン制御
const showAllTanzakuEditBtn = ref(false);
const checkSelectFlg = () => {
  let isSelected = false;
  multiOrder_list.value.forEach((list) => {
    if (list.selectFlg) isSelected = true;
  });
  showAllTanzakuEditBtn.value = isSelected;
};
// 編集ボタンクリック
const clickAllTanzakuEdit = () => {
  showTanzakuModal();
};

// モーダル関連------------------------------------------------
// 短冊一括設定モーダル
const tanzakuModalVisible = ref(false); // 短冊モーダル表示制御フラグ
// const selectedMeisai = ref({} as MultiOrderList); // 短冊モーダルに渡す明細情報
const showTanzakuModal = () => {
  tanzakuModalVisible.value = true;
};
const closeTanzakuModal = () => {
  tanzakuModalVisible.value = false;
};
const addTanzakuInfo = (tanzakuData: { memo: string }) => {
  multiOrder_list.value.forEach((list) => {
    if (list.selectFlg) list.tanzaku = tanzakuData.memo;
  });
  tanzakuModalVisible.value = false;
};

// 書店コードモーダル
const shopModalVisible = ref(false); // 表示制御フラグ
const propToritugiCd = ref(""); // 書店検索モーダルに渡す取次CD
let changeSyotenTarget = ref({} as MultiOrderList);
let heldSyotenCd = "";
// 直接コード入力されたとき↓↓
const focusSyotenCd = (event: any, orderIndex: number) => {
  heldSyotenCd = event.target.value;
  changeSyotenTarget.value = multiOrder_list.value[orderIndex];
};
const searchSyoten = async (): Promise<void> => {
  store.commit("search/setSyotenDetailState", {
    toritugiCd: changeSyotenTarget.value.toritugiCd,
    toritugiSyotenCd: changeSyotenTarget.value.toritugisyotenCd,
  });
  // 入力値が空だったら各値をリセットする
  if (changeSyotenTarget.value.toritugisyotenCd === "") {
    changeSyotenTarget.value.toritugisyotenMei = "";
    changeSyotenTarget.value.toritugisyotenCd = "";
    changeSyotenTarget.value.bansen = "";
  } else {
    await store.dispatch("search/searchToritugiSyotenCd");
    const res = store.getters["search/getSyotenData"];
    if (res.syotenToritugiList.length > 0) {
      ref_selectSyoten(res.syotenToritugiList[0]);
      changeSyotenTarget.value.syosiMei = res.syotenToritugiList[0].syotenCd;
      changeSyotenTarget.value.toritugisyotenCd =
        res.syotenToritugiList[0].toritugiSyotenCd;
      changeSyotenTarget.value.bansen = res.syotenToritugiList[0].bansen;
    } else {
      //該当する書店が無ければ以前の状態に戻す
      changeSyotenTarget.value.toritugisyotenCd = heldSyotenCd;
      notyf.error("該当する書店がありません");
    }
  }
};
// モーダルから検索されたとき↓↓
const openSearchSyotenModal = (orderIndex: number) => {
  changeSyotenTarget.value = multiOrder_list.value[orderIndex];
  propToritugiCd.value = multiOrder_list.value[orderIndex].toritugiCd;
  shopModalVisible.value = true;
};
const ref_selectSyoten = (selectedValue: {
  syotenMei: string;
  syotenCd: string;
  bansen: string;
  toritugiCd: string;
  toritugiSyotenCd: string;
}) => {
  changeSyotenTarget.value.toritugisyotenMei = selectedValue.syotenMei;
  changeSyotenTarget.value.toritugisyotenCd = selectedValue.toritugiSyotenCd;
  changeSyotenTarget.value.bansen = selectedValue.bansen;
  changeSyotenTarget.value.toritugiCd = selectedValue.toritugiCd;
};

// 書誌検索モーダル
const syosiModalVisible = ref(false); // 表示制御フラグ
let changeSyosiTarget = ref({} as MultiOrderList);
let holdSyosiCord = "";
// 直接コード入力されたとき↓↓
const focusSyosiCd = (orderIndex: number) => {
  changeSyosiTarget.value = multiOrder_list.value[orderIndex];
  holdSyosiCord = multiOrder_list.value[orderIndex].searchSyosiCord;
};
const searchSyosi = async (event: any): Promise<void> => {
  // 入力値が空だったら各値をリセットする
  if (event.target.value === "") {
    changeSyosiTarget.value.hontaiPrice = null;
    changeSyosiTarget.value.janCd = "";
    changeSyosiTarget.value.syuppanSyosiCd = "";
    changeSyosiTarget.value.syosiCd = "";
    changeSyosiTarget.value.syosiMei = "";
    changeSyosiTarget.value.availableAmount = null;
    changeSyosiTarget.value.holdSum = null;
    changeSyosiTarget.value.shinagireHoryuSuu = null;
    changeSyosiTarget.value.searchSyosiCord = "";
    changeSyosiTarget.value.zsId = "";
    changeSyosiTarget.value.zsName = "";
    changeSyosiTarget.value.zsNameDisplay = "";
    changeSyosiTarget.value.cutting = "";
    return;
  } else {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi?syosiCd=${event.target.value}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.data.syosiList.length > 0) {
      ref_selectSyosi(res.data.syosiList[0]);
    } else {
      changeSyosiTarget.value.searchSyosiCord = holdSyosiCord;
    }
  }
};
// モーダルから検索されたとき↓↓
const openSearchSyosiModal = (orderIndex: number) => {
  changeSyosiTarget.value = multiOrder_list.value[orderIndex];
  syosiModalVisible.value = true;
};
const ref_selectSyosi = (selectedValue: ZaikoData) => {
  changeSyosiTarget.value.hontaiPrice = selectedValue.hontaiPrice;
  changeSyosiTarget.value.janCd = selectedValue.janCd;
  changeSyosiTarget.value.syuppanSyosiCd = selectedValue.syuppanSyosiCd;
  changeSyosiTarget.value.syosiCd = selectedValue.syosiCd;
  changeSyosiTarget.value.syosiMei = selectedValue.title;
  changeSyosiTarget.value.availableAmount = selectedValue.availableAmount;
  changeSyosiTarget.value.holdSum = selectedValue.holdSum;
  changeSyosiTarget.value.shinagireHoryuSuu = selectedValue.shinagireHoryuSuu;
  if (syosiModalVisible.value) {
    changeSyosiTarget.value.searchSyosiCord = selectedValue.janCd;
  }
  changeSyosiTarget.value.zsId = selectedValue.zsId as string;
  changeSyosiTarget.value.zsName = selectedValue.zsName as string;
  changeSyosiTarget.value.zsNameDisplay = selectedValue.zsNameDisplay as string;
  changeSyosiTarget.value.cutting = selectedValue.cutting as string;
};

// 引継ぎ項目関連----------------------------------------------
const hikitsugi_list = ref([
  { name: "取次", selectFlg: false, isActiveTakeOverFlg: false },
  { name: "書店", selectFlg: false, isActiveTakeOverFlg: false },
  { name: "書誌", selectFlg: false, isActiveTakeOverFlg: false },
  { name: "依頼者", selectFlg: false, isActiveTakeOverFlg: false },
  { name: "冊数", selectFlg: false, isActiveTakeOverFlg: false },
]);
const selectHikitsugi = (hikitsugi: HikitsugiList) => {
  hikitsugi.selectFlg = !hikitsugi.selectFlg;
  if (hikitsugi.selectFlg) {
    hikitsugi.isActiveTakeOverFlg = true;
    setTimeout(() => {
      hikitsugi.isActiveTakeOverFlg = false;
    }, 2000);
  }
};
const isActiveHighlight = () => {
  hikitsugi_list.value.forEach((hikitsugi) => {
    if (hikitsugi.selectFlg) {
      hikitsugi.isActiveTakeOverFlg = true;
      setTimeout(() => {
        hikitsugi.isActiveTakeOverFlg = false;
      }, 2000);
    }
  });
};

// 明細追加関連-----------------------------------------------
const addMultiOrderList = () => {
  const lastData = multiOrder_list.value[multiOrder_list.value.length - 1];
  // 全て削除後の追加の場合は初期値をセット
  if (lastData === undefined) {
    multiOrder_list.value.push({
      // 保存時に引数で渡すデータ
      hanmotoCd: userInfo.hanmotoCd,
      userId: userInfo.userId,
      janCd: "",
      quantity: "",
      toritugiCd: "",
      toritugisyotenCd: "",
      toritugisyotenMei: "",
      bansen: "",
      salesName: initSalesCd.value,
      tanzaku: "",
      isHold: false,
      // 画面表示のみのデータ
      meisaiNo: 1,
      syosiCd: "",
      syuppanSyosiCd: "",
      hontaiPrice: null,
      syosiMei: "",
      availableAmount: null, // 使用可能数
      holdSum: null, // 受注保留数
      shinagireHoryuSuu: null, // 品切保留数
      tanzakuFlg: false, // 短冊データの有無
      selectFlg: false,
      searchSyosiCord: "",
      zsId: "",
      zsName: "",
      zsNameDisplay: "",
      cutting: "",
    });
  } else {
    multiOrder_list.value.push({
      // 保存時に引数で渡すデータ
      hanmotoCd: "",
      userId: null,
      janCd: hikitsugi_list.value.find((hikitsugi) => hikitsugi.name === "書誌")
        ?.selectFlg
        ? lastData.janCd
        : "",
      quantity: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "冊数"
      )?.selectFlg
        ? lastData.quantity
        : "",
      toritugiCd:
        hikitsugi_list.value.find((hikitsugi) => hikitsugi.name === "取次")
          ?.selectFlg ||
        hikitsugi_list.value.find((hikitsugi) => hikitsugi.name === "書店")
          ?.selectFlg
          ? lastData.toritugiCd
          : "",
      toritugisyotenCd: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書店"
      )?.selectFlg
        ? lastData.toritugisyotenCd
        : "",
      toritugisyotenMei: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書店"
      )?.selectFlg
        ? lastData.toritugisyotenMei
        : "",
      bansen: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書店"
      )?.selectFlg
        ? lastData.bansen
        : "",
      salesName: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "依頼者"
      )?.selectFlg
        ? lastData.salesName
        : initSalesCd.value,
      tanzaku: "",
      isHold: false,
      // 画面表示のみのデータ
      meisaiNo: 1,
      syosiCd: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.syosiCd
        : "",
      syuppanSyosiCd: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.syuppanSyosiCd
        : "",
      hontaiPrice: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.hontaiPrice
        : null,
      syosiMei: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.syosiMei
        : "",
      availableAmount: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.availableAmount
        : null,
      holdSum: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.holdSum
        : null,
      shinagireHoryuSuu: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.shinagireHoryuSuu
        : null,
      tanzakuFlg: false,
      selectFlg: false,
      searchSyosiCord: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.searchSyosiCord
        : "",
      zsId: hikitsugi_list.value.find((hikitsugi) => hikitsugi.name === "書誌")
        ?.selectFlg
        ? lastData.zsId
        : "",
      zsName: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.zsName
        : "",
      zsNameDisplay: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.zsNameDisplay
        : "",
      cutting: hikitsugi_list.value.find(
        (hikitsugi) => hikitsugi.name === "書誌"
      )?.selectFlg
        ? lastData.cutting
        : "",
    });
  }

  isActiveHighlight();
  updateMeisaiNo();
  nextTick(function () {
    toScrollTableBottom();
  });
};
const updateMeisaiNo = () => {
  multiOrder_list.value.forEach((order, index) => {
    order.meisaiNo = index + 1;
  });
};
const scrollTable = ref();
const toScrollTableBottom = () => {
  let el = scrollTable.value;
  if (el) {
    el.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "start",
    });
  }
};

// 明細削除関連----------------------------------------------
const deleteMultiOrderList = (index: number) => {
  if (confirm(`明細${index + 1}の注文を削除してもよろしいですか？`)) {
    multiOrder_list.value.splice(index, 1);
    updateMeisaiNo();
    if (multiOrder_list.value.length == 0) {
      addMultiOrderList();
    }
  }
};
const deleteAllMultiOrderList = () => {
  if (confirm("すべて削除してもよろしいですか？")) {
    multiOrder_list.value.splice(0, multiOrder_list.value.length);
    addMultiOrderList();
  }
};

// 保留設定一括選択----------------------------------------------
const highlightHold = ref(false);
const selectBar_hold = ref({
  title: "保留設定一括",
  select_list: [
    { name: "保留", selectFlg: false },
    { name: "保留しない", selectFlg: false },
  ],
});
const updateSelectHold = (newVal: any): void => {
  multiOrder_list.value.forEach((item) => {
    if (newVal.name == "保留") {
      item.isHold = true;
    } else {
      item.isHold = false;
    }
  });
  highlightHold.value = true;
  setTimeout(() => {
    highlightHold.value = false;
  }, 2000);
};

// Excel関連------------------------------------------
// ダウンロード関連
const isDownloading = ref(false); // ダウンロード中フラグ
const downloadSelectBoxFlg = ref(false); // ダウンロードメニュー開閉フラグ
// ダウンロードメニューの開閉
const toggleDownloadSelectBox = () => {
  downloadSelectBoxFlg.value = !downloadSelectBoxFlg.value;
};
// ダウンロードボタン外をクリックしたときにメニューを閉じる
const downloadOutsideClick = () => {
  downloadSelectBoxFlg.value = false;
};

// ダウンロード処理
const getExcelData = async (type: string) => {
  isDownloading.value = true;
  try {
    const url =
      type === "normal"
        ? `${store.getters["getBaseUrl"]}/chumon/multi/downloadeExcelTemplate`
        : `${store.getters["getBaseUrl"]}/chumon/multi/downloadExcelSimpleTemplate`;
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      responseType: "arraybuffer",
      responseEncoding: "binary",
    });
    downloadFile(res, type);
  } catch (error) {
    isDownloading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadFile = (resData: any, type: string) => {
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download =
    type === "normal" ? `マルチ入力_通常版.xlsx` : `マルチ入力_簡易版.xlsx`;
  link.click();
  isDownloading.value = false;
};

// アップロード関連
const isUploading = ref(false); // アップロード中フラグ
const inputFile = ref();
let error = reactive({
  hasError: false,
  message: "",
});
watch(
  () => error,
  () => {
    if (error.hasError === true) {
      isUploading.value = false;
      notyf.error({
        duration: 10000,
        message: error.message,
      });
    }
  },
  { deep: true }
);
const onClickUpload = () => {
  //「アップロード」ボタンを押下すると非表示中のinput=fileが発火する
  inputFile.value.click();
};
const resetFile = (e: any) => {
  e.target.value = "";
  error.hasError = false;
  error.message = "";
};
let FILE: any;
const uploadFile = (e: any) => {
  isUploading.value = true;
  FILE = e.target.files[0];
  const READER = new FileReader();

  READER.onload = async (e: any) => {
    // ↓フロントでのバリデーションを行わない
    // const Utils = xlsx.utils; // XLSX.utilsのalias
    // // ブラウザからのファイルリード結果を変数に保存
    // let DATA = e.target.result;
    // let arr = fixdata(DATA);
    // let wb;
    // wb = xlsx.read(btoa(arr), {
    //   type: "base64",
    //   cellDates: true,
    // });
    // const sheetNames = wb.SheetNames;

    // // wbの空セルがundefinedになるため空文字を入れる
    // const fillCell = (workSheet: xlsx.WorkSheet) => {
    //   // const sheetNames = wb.SheetNames;
    //   // const workSheet = wb.Sheets[sheetNames[1]];

    //   // セルの範囲
    //   const range = workSheet["!ref"];
    //   if (range !== undefined) {
    //     // セル範囲を数値表現に変換
    //     const decodeRange = Utils.decode_range(range as string);

    //     for (
    //       let rowIndex = decodeRange.s.r;
    //       rowIndex <= decodeRange.e.r;
    //       rowIndex++
    //     ) {
    //       for (
    //         let colIndex = decodeRange.s.c;
    //         colIndex <= decodeRange.e.c;
    //         colIndex++
    //       ) {
    //         // 数値表現をセルアドレス ("A1"など) に変換
    //         const address = Utils.encode_cell({ r: rowIndex, c: colIndex });
    //         let cell = workSheet[address];

    //         if (typeof cell === "undefined" || typeof cell.v === "undefined") {
    //           workSheet[address] = { t: "s", v: "", w: "" };
    //         }
    //       }
    //     }
    //     // xlsx.writeFile(wb)
    //   }
    //   return workSheet;
    // };

    // // ExcelデータをJSON形式に変換しエラーバリデーションを行う
    // // 通常版
    // if (FILE.name.includes("マルチ入力_通常版")) {
    //   // isbn,書名,書店情報を取得---------------------------------------
    //   let targetSheet = wb.Sheets[sheetNames[0]];
    //   targetSheet = fillCell(targetSheet);

    //   // データ範囲最後のセルを特定
    //   const lastColumn = targetSheet["!ref"]?.slice(
    //     targetSheet["!ref"]?.indexOf(":") + 1
    //   );
    //   const lastColumnAlp = lastColumn?.match(/[A-Z]/g)?.join("");

    //   // isbn,書名,短冊メモ
    //   targetSheet["!ref"] = `E1:${lastColumnAlp}4`;
    //   const syosiInfoArray: any[] = xlsx.utils.sheet_to_json(targetSheet);
    //   if (!(syosiInfoArray.length > 0)) {
    //     error.hasError = true;
    //     error.message = "フォーマットが異なるためアップロードできません";
    //     return;
    //   } else if ("" in syosiInfoArray[0]) {
    //     syosiInfoArray.forEach((syosi) => {
    //       // ヘッダーに特定のキーが含まれていなければエラー
    //       if (
    //         syosi[""] !== "【必須】ISBN" &&
    //         syosi[""] !== "書名" &&
    //         syosi[""] !== "短冊メモ"
    //       ) {
    //         error.hasError = true;
    //         error.message = "フォーマットが異なるためアップロードできません";
    //         return;
    //       }
    //       // isbnの型が文字列以外ならエラー
    //       else if (syosi[""] === "【必須】ISBN") {
    //         for (let isbn in syosi) {
    //           if (isbn !== "" && typeof syosi[isbn] !== "string") {
    //             error.hasError = true;
    //             error.message = "isbnを文字列形式で入力してください";
    //             return;
    //           }
    //         }
    //       }
    //     });
    //     if (error.hasError === true) return;
    //   }
    //   // ヘッダーに特定のキーが含まれていなければエラー
    //   else {
    //     error.hasError = true;
    //     error.message = "フォーマットが異なるためアップロードできません";
    //     return;
    //   }

    //   // 書店情報
    //   const syotenKeys = [
    //     "行",
    //     "書店名",
    //     "【必須】取協コード",
    //     "【必須】取次書店コード",
    //     "番線",
    //     "部数",
    //   ];
    //   targetSheet["!ref"] = `A5:${lastColumn}`;
    //   const syotenInfoArray: any[] = xlsx.utils.sheet_to_json(targetSheet);
    //   if (!(syotenInfoArray.length > 0)) {
    //     error.hasError = true;
    //     error.message = "フォーマットが異なるためアップロードできません";
    //     return;
    //   } else {
    //     for (let syotenInfo of syotenInfoArray) {
    //       // ヘッダーに特定のキーが含まれていなければエラー
    //       if (
    //         Object.keys(syotenInfo).filter((key) => syotenKeys.includes(key))
    //           .length !== syotenKeys.length
    //       ) {
    //         error.hasError = true;
    //         error.message = "フォーマットが異なるためアップロードできません";
    //         break;
    //       }
    //       // 取協コード,取次書店コード,番線の型が文字列以外ならエラー
    //       else if (
    //         typeof syotenInfo["【必須】取協コード"] !== "string" ||
    //         typeof syotenInfo["【必須】取次書店コード"] !== "string" ||
    //         typeof syotenInfo["番線"] !== "string"
    //       ) {
    //         error.hasError = true;
    //         error.message =
    //           "取協コード,取次書店コード,番線は文字列で入力してください";
    //         break;
    //       }
    //     }
    //     if (error.hasError === true) return;
    //   }
    // }

    // // 簡易版
    // else if (FILE.name.includes("マルチ入力_簡易版")) {
    //   let targetSheet = wb.Sheets[sheetNames[0]];
    //   targetSheet = fillCell(targetSheet);
    //   const kaniMultiArray: any[] = xlsx.utils.sheet_to_json(targetSheet);
    //   const keys = [
    //     "行",
    //     "書店名",
    //     "【必須】取協コード",
    //     "【必須】取次書店コード",
    //     "番線",
    //     "【必須】ISBN",
    //     "書名",
    //     "【必須】部数",
    //     "短冊メモ",
    //   ];
    //   if (!(kaniMultiArray.length > 0)) {
    //     error.hasError = true;
    //     error.message = "フォーマットが異なるためアップロードできません";
    //     return;
    //   } else {
    //     for (let kaniInfo of kaniMultiArray) {
    //       // ヘッダーに特定のキーが含まれていなければエラー
    //       if (
    //         Object.keys(kaniInfo).filter((key) => keys.includes(key)).length !==
    //         keys.length
    //       ) {
    //         error.hasError = true;
    //         error.message = "フォーマットが異なるためアップロードできません";
    //         break;
    //       }
    //       // ISBN,取協コード,取次書店コード,番線の型が文字列以外ならエラー
    //       else if (
    //         typeof kaniInfo["【必須】ISBN"] !== "string" ||
    //         typeof kaniInfo["【必須】取協コード"] !== "string" ||
    //         typeof kaniInfo["【必須】取次書店コード"] !== "string" ||
    //         typeof kaniInfo["番線"] !== "string"
    //       ) {
    //         error.hasError = true;
    //         error.message =
    //           "ISBN,取協コード,取次書店コード,番線は文字列で入力してください";
    //         break;
    //       }
    //     }
    //     if (error.hasError === true) return;
    //   }
    // }
    // // その他
    // else {
    //   error.hasError = true;
    //   error.message =
    //     "ファイル名には「マルチ入力_通常版」または「マルチ入力_簡易版」のいずれかを含めてください";
    //   return;
    // }

    const formData = new FormData();
    formData.append("multipartFile", FILE);
    uploadToServer(formData);
  };
  // Fileオブジェクトバイナリデータとしてメモリ上に読み込む（読み込んだらonload部分を実行する）
  READER.readAsArrayBuffer(FILE);
};

//EXCELファイルの読み込み
const fixdata = (DATA: any) => {
  let o = "",
    l = 0,
    w = 10240;
  for (; l < DATA.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(DATA.slice(l * w, l * w + w)) as any
    );
  o += String.fromCharCode.apply(
    null,
    new Uint8Array(DATA.slice(l * w)) as any
  );
  return o;
};
// サーバーに投げる
const uploadToServer = async (sendData: any) => {
  const url = `${store.getters["getBaseUrl"]}/chumon/multi/uploadExcel`;
  try {
    let isAccept = true;
    if (JSON.stringify(multiOrder_list.value) !== initialData.value) {
      isAccept = confirm("入力データが削除されますがよろしいですか？");
    }
    if (isAccept) {
      hasCartError.value = false;
      multiOrder_list.value.splice(0);
      const res = await axios.post(url, sendData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "content-type": "multipart/form-data",
        },
      });
      res.data.forEach((resData: any) => {
        multiOrder_list.value.push({
          // 保存時に引数で渡すデータ
          hanmotoCd: userInfo.hanmotoCd,
          userId: userInfo.userId,
          janCd: resData.janCd,
          quantity: resData.quantity,
          toritugiCd: resData.toritugiCd,
          toritugisyotenCd: resData.toritugiSyotenCd,
          toritugisyotenMei: resData.toritugiSyotenMei,
          bansen: resData.bansen,
          salesName: initSalesCd.value,
          tanzaku: resData.tanzaku,
          isHold: false,
          // 画面表示のみのデータ
          meisaiNo: 1,
          syosiCd: resData.syosiCd,
          syuppanSyosiCd: "",
          hontaiPrice: resData.hontaiPrice,
          syosiMei: resData.title,
          availableAmount: resData.availableAmount, // 使用可能数
          holdSum: resData.holdSum, // 受注保留数
          shinagireHoryuSuu: resData.shinagireSum, // 品切保留数
          tanzakuFlg: false, // 短冊データの有無
          selectFlg: false,
          searchSyosiCord: "",
          zsId: resData.zsId,
          zsName: resData.zsName,
          zsNameDisplay: resData.zsNameDisplay,
          cutting: resData.cutting,
        });
      });
      updateMeisaiNo();
      // console.log(multiOrder_list.value);

      isUploading.value = false;
    } else {
      isUploading.value = false;
    }
  } catch (error) {
    isUploading.value = false;
    // 404エラーの場合（DBに存在しないデータが入力された場合）、エラー内容をExcelでダウンロードする
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      // エラー内容のダウンロード
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
      downloadErrorFile(error.response?.data);
      // 取り込み完了分のデータ表示
      const displayData = error.response?.data.displayData;
      if (displayData.length > 0) {
        displayData.forEach((resData: any) => {
          multiOrder_list.value.push({
            // 保存時に引数で渡すデータ
            hanmotoCd: userInfo.hanmotoCd,
            userId: userInfo.userId,
            janCd: resData.janCd,
            quantity: resData.quantity,
            toritugiCd: resData.toritugiCd,
            toritugisyotenCd: resData.toritugiSyotenCd,
            toritugisyotenMei: resData.toritugiSyotenMei,
            bansen: resData.bansen,
            salesName: initSalesCd.value,
            tanzaku: resData.tanzaku,
            isHold: false,
            // 画面表示のみのデータ
            meisaiNo: 1,
            syosiCd: resData.syosiCd,
            syuppanSyosiCd: "",
            hontaiPrice: resData.hontaiPrice,
            syosiMei: resData.title,
            availableAmount: resData.availableAmount, // 使用可能数
            holdSum: resData.holdSum, // 受注保留数
            shinagireHoryuSuu: resData.shinagireSum, // 品切保留数
            tanzakuFlg: false, // 短冊データの有無
            selectFlg: false,
            searchSyosiCord: "",
            zsId: resData.zsId,
            zsName: resData.zsName,
            zsNameDisplay: resData.zsNameDisplay,
            cutting: resData.cutting,
          });
        });
        updateMeisaiNo();
      }
    } else if (axios.isAxiosError(error) && error.response?.data.userMessage) {
      // console.log(error.response?.status);
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
    } else {
      alert("アップロードに失敗しました");
    }
  }
};
// エラーExcelのダウンロード
const downloadErrorFile = async (errorInfo: any) => {
  isUploading.value = true;
  const formData = new FormData();
  formData.append("file", FILE);
  formData.append(
    "errorJanCdCellData",
    new Blob([JSON.stringify(errorInfo.errorJanCdCellData)], {
      type: "application/json",
    })
  );
  formData.append(
    "errorSyotenInfoCellData",
    new Blob([JSON.stringify(errorInfo.errorSyotenInfoCellData)], {
      type: "application/json",
    })
  );
  try {
    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/chumon/multi/error-download-excel`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "content-type": "multipart/form-data",
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );

    // Excelファイルのダウンロード
    let blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `マルチ入力アップロード_エラー内容.xlsx`;
    link.click();
    isUploading.value = false;
  } catch (error) {
    alert("エラー内容の取得に失敗しました");
    console.log(error);
  }
};

// カート追加関連----------------------------------------------
// バリデーションエラー関連変数
const hasCartError = ref(false);
const cartErrorInfo = ref([
  {
    index: -1,
    type: "",
    message: "",
  },
]);
const judgeCartError = (multiListIndex: number, type: string) => {
  const findedCartError = cartErrorInfo.value.find((cartError) => {
    return cartError.index === multiListIndex && cartError.type === type;
  });
  if (findedCartError === undefined) return null;
  else return findedCartError.message;
};
const addOrderToCart = async () => {
  let zeppanItem = [] as MultiOrderList[];
  if (JSON.stringify(multiOrder_list.value) !== initialData.value) {
    // バリデーションを実施
    hasCartError.value = false;
    cartErrorInfo.value.splice(0);
    multiOrder_list.value.forEach((multiOrder, index) => {
      // 取次
      if (multiOrder.toritugiCd === "" || multiOrder.toritugiCd === null) {
        hasCartError.value = true;
        cartErrorInfo.value.push({
          index: index,
          type: "toritugi",
          message: "入力してください",
        });
      }
      // 書店情報
      if (
        multiOrder.toritugisyotenCd === "" ||
        multiOrder.toritugisyotenCd === null
      ) {
        hasCartError.value = true;
        cartErrorInfo.value.push({
          index: index,
          type: "syoten",
          message: "入力してください",
        });
      }
      // 商品情報
      if (multiOrder.janCd === "" || multiOrder.janCd === null) {
        hasCartError.value = true;
        cartErrorInfo.value.push({
          index: index,
          type: "syosi",
          message: "入力してください",
        });
      }
      // 受注数
      if (
        multiOrder.quantity === "" ||
        multiOrder.quantity === "0" ||
        Number(multiOrder.quantity) === 0
      ) {
        hasCartError.value = true;
        cartErrorInfo.value.push({
          index: index,
          type: "quantity",
          message: "入力してください",
        });
      }
      // 短冊
      if (isValidTanzaku.value(multiOrder.tanzaku)) {
        hasCartError.value = true;
      }
      // 絶版・全量廃棄が含まれる場合配列に格納
      if (multiOrder.zsId === "34" || multiOrder.cutting === "4:全量廃棄") {
        zeppanItem.push(multiOrder);
      }
    });

    if (hasCartError.value) {
      notyf.error({ duration: 10000, message: "入力内容を確認してください" });
    } else if (zeppanItem.length > 0) {
      // 絶版・全量廃棄が含まれる場合アラートモーダル表示
      zeppanItems.value = zeppanItem;
      alertModalVisible.value = true;
    } else {
      const sendData = [
        {
          addNumber: -1,
          hanmotoCd: "",
          userId: -1,
          janCd: "",
          quantity: -1,
          toritugiCd: "",
          toritugiSyotenCd: "",
          tanzaku: "",
          bansen: "",
          salesName: -1 as number | null,
          isHold: false,
        },
      ];
      sendData.splice(0);
      multiOrder_list.value.forEach((multiOrder) => {
        sendData.push({
          addNumber: multiOrder.meisaiNo,
          hanmotoCd: multiOrder.hanmotoCd,
          userId: multiOrder.userId as number,
          janCd: multiOrder.janCd,
          quantity: Number(multiOrder.quantity),
          toritugiCd: multiOrder.toritugiCd,
          toritugiSyotenCd: multiOrder.toritugisyotenCd,
          tanzaku: multiOrder.tanzaku,
          bansen: multiOrder.bansen,
          salesName:
            typeof multiOrder.salesName === "number"
              ? multiOrder.salesName
              : null,
          isHold: multiOrder.isHold,
        });
      });
      // console.log(sendData);

      try {
        const res = await axios.post(
          `${store.getters["getBaseUrl"]}/chumon/multi/addCart`,
          sendData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        notyf.success("カートに製品を追加しました");
        multiOrder_list.value.splice(0);
        multiOrder_list.value.push({
          // 保存時に引数で渡すデータ
          hanmotoCd: userInfo.hanmotoCd,
          userId: userInfo.userId,
          janCd: "",
          quantity: "",
          toritugiCd: "",
          toritugisyotenCd: "",
          toritugisyotenMei: "",
          bansen: "",
          salesName: initSalesCd.value,
          tanzaku: "",
          isHold: false,
          // 画面表示のみのデータ
          meisaiNo: 1,
          syosiCd: "",
          syuppanSyosiCd: "",
          hontaiPrice: null,
          syosiMei: "",
          availableAmount: null, // 使用可能数
          holdSum: null, // 受注保留数
          shinagireHoryuSuu: null, // 品切保留数
          tanzakuFlg: false, // 短冊データの有無
          selectFlg: false,
          searchSyosiCord: "",
          zsId: "",
          zsName: "",
          zsNameDisplay: "",
          cutting: "",
        });
      } catch (error) {
        console.log(error);
        if (axios.isAxiosError(error) && error.response?.data.userMessage) {
          notyf.error({
            duration: 10000,
            message: error.response?.data.userMessage,
          });
        } else {
          alert("カート追加に失敗しました");
        }
      }
    }
  }
};

// カート追加時アラート関連-------------------------------------
const alertModalVisible = ref(false); // モーダル開閉制御
const zeppanItems = ref([] as MultiOrderList[]); // 絶版商品一覧
// モーダルクローズ
const closeAlertModal = () => {
  alertModalVisible.value = false;
};
// アラートconfirm後のカート追加処理
const confirmedAlert = async (
  isConfirm: boolean,
  isTandoku: boolean,
  tandokuSyosiInfo: undefined
) => {
  const sendData = [
    {
      addNumber: -1,
      hanmotoCd: "",
      userId: -1,
      janCd: "",
      quantity: -1,
      toritugiCd: "",
      toritugiSyotenCd: "",
      tanzaku: "",
      bansen: "",
      salesName: -1 as number | null,
      isHold: false,
    },
  ];
  sendData.splice(0);
  // カート追加する商品の抽出
  // 絶版・全量廃棄商品を除外する場合
  if (isConfirm) {
    multiOrder_list.value.forEach((multiOrder) => {
      if (!(multiOrder.zsId === "34" || multiOrder.cutting === "4:全量廃棄")) {
        sendData.push({
          addNumber: multiOrder.meisaiNo,
          hanmotoCd: multiOrder.hanmotoCd,
          userId: multiOrder.userId as number,
          janCd: multiOrder.janCd,
          quantity: Number(multiOrder.quantity),
          toritugiCd: multiOrder.toritugiCd,
          toritugiSyotenCd: multiOrder.toritugisyotenCd,
          tanzaku: multiOrder.tanzaku,
          bansen: multiOrder.bansen,
          salesName:
            typeof multiOrder.salesName === "number"
              ? multiOrder.salesName
              : null,
          isHold: multiOrder.isHold,
        });
      }
    });
  }
  // 除外しない場合
  else {
    multiOrder_list.value.forEach((multiOrder) => {
      sendData.push({
        addNumber: multiOrder.meisaiNo,
        hanmotoCd: multiOrder.hanmotoCd,
        userId: multiOrder.userId as number,
        janCd: multiOrder.janCd,
        quantity: Number(multiOrder.quantity),
        toritugiCd: multiOrder.toritugiCd,
        toritugiSyotenCd: multiOrder.toritugisyotenCd,
        tanzaku: multiOrder.tanzaku,
        bansen: multiOrder.bansen,
        salesName:
          typeof multiOrder.salesName === "number"
            ? multiOrder.salesName
            : null,
        isHold: multiOrder.isHold,
      });
    });
  }
  // カート追加処理
  try {
    if (sendData.length > 0) {
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/multi/addCart`,
        sendData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      notyf.success("カートに製品を追加しました");
    }
    multiOrder_list.value.splice(0);
    multiOrder_list.value.push({
      // 保存時に引数で渡すデータ
      hanmotoCd: userInfo.hanmotoCd,
      userId: userInfo.userId,
      janCd: "",
      quantity: "",
      toritugiCd: "",
      toritugisyotenCd: "",
      toritugisyotenMei: "",
      bansen: "",
      salesName: initSalesCd.value,
      tanzaku: "",
      isHold: false,
      // 画面表示のみのデータ
      meisaiNo: 1,
      syosiCd: "",
      syuppanSyosiCd: "",
      hontaiPrice: null,
      syosiMei: "",
      availableAmount: null, // 使用可能数
      holdSum: null, // 受注保留数
      shinagireHoryuSuu: null, // 品切保留数
      tanzakuFlg: false, // 短冊データの有無
      selectFlg: false,
      searchSyosiCord: "",
      zsId: "",
      zsName: "",
      zsNameDisplay: "",
      cutting: "",
    });
  } catch (error) {
    console.log(error);
    if (axios.isAxiosError(error) && error.response?.data.userMessage) {
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
    } else {
      alert("カート追加に失敗しました");
    }
  }
};

// エンターキーでの移動用--------------------------------
const { creatMoveWithEnterElms, moveNext, movePrev } = common();
let moveWithEnterElms = ref([] as HTMLElement[]);
watch(multiOrder_list.value, async () => {
  moveWithEnterElms.value = await creatMoveWithEnterElms();
});

// キークリック関連------------------------
const onKeyDown = (e: any, orderIndex?: number) => {
  // console.log(e);
  // 明細内最後の項目でエンターまたはタブを押すと明細を追加
  if (
    orderIndex === multiOrder_list.value.length - 1 &&
    (e.key === "Tab" || e.key === "Enter") &&
    e.target.id === "Tanzaku_Input"
  ) {
    e.preventDefault();
    addMultiOrderList();
  }
  // エンターで次項目にフォーカス
  else if (e.key === "Enter" && !e.altKey && !e.ctrlKey && !e.shiftKey) {
    e.preventDefault();
    moveNext(e, moveWithEnterElms.value);
  }
  // シフト+エンターで前項目にフォーカス
  else if (e.key === "Enter" && !e.altKey && !e.ctrlKey && e.shiftKey) {
    e.preventDefault();
    movePrev(e, moveWithEnterElms.value);
  }
};
onMounted(async () => {
  document.addEventListener("keydown", onKeyDown);
  moveWithEnterElms.value = await creatMoveWithEnterElms();
});

// 他----------------------------------------------------
//取次
const toritugiList = computed(() => {
  return store.getters["constant/getToritugiList"];
});
// 合計冊数の計算
const totalNumberOfBooks = computed(() => {
  let total = 0;
  multiOrder_list.value.forEach((list) => {
    total += Number(list.quantity);
  });
  return total.toLocaleString();
});

// // 表示条件関連（表示項目が不要になったのでコメントアウト）
// // 取置
// let selectedToriokiList: { juchuToriokiNo: any } | null = null;
// const toriokiModalVisible = ref(false);
// const isActiveTorioki = ref(false);
// const showToriokiModal = (order: any) => {
//   selectedToriokiList = order;
//   toriokiModalVisible.value = true;
// };
// const closeToriokiModal = () => {
//   toriokiModalVisible.value = false;
// };
// const setTorioki = (torioki: { toriokiKanriNo: any }) => {
//   if (selectedToriokiList) {
//     selectedToriokiList.juchuToriokiNo = torioki.toriokiKanriNo;
//   }
// };

// // 条件
// const isActiveJyoken = ref(false);
// const selectEventKbn = (order: MultiOrderList, event: any) => {
//   if (event.target.value !== "2" && event.target.value !== "3") {
//     order.errorFlg = false;
//   }
// };
// const checkTextLength = (event: any, order: MultiOrderList) => {
//   if (event.target.value.length >= 3) {
//     order.errorFlg = true;
//     order.jyokenKikan = "";
//   } else {
//     order.errorFlg = false;
//   }
// };

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OrderFormMulti", {
      SideBar_False: !__props.isActive_SidebarFlg,
      SideBar_True: __props.isActive_SidebarFlg,
    }]),
    id: "page-bottom"
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    (tanzakuModalVisible.value)
      ? (_openBlock(), _createBlock(ModalMultiTanzaku, {
          key: 0,
          onClose: closeTanzakuModal,
          onAddTanzakuInfo: addTanzakuInfo
        }))
      : _createCommentVNode("", true),
    (shopModalVisible.value)
      ? (_openBlock(), _createBlock(ModalShopList, {
          key: 1,
          toritugiCd: propToritugiCd.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (shopModalVisible.value = false)),
          onRef_selectSyoten: ref_selectSyoten
        }, null, 8, ["toritugiCd"]))
      : _createCommentVNode("", true),
    (syosiModalVisible.value)
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 2,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (syosiModalVisible.value = false)),
          onRef_selectSyosi: ref_selectSyosi
        }))
      : _createCommentVNode("", true),
    (alertModalVisible.value)
      ? (_openBlock(), _createBlock(ModalCartAlert, {
          key: 3,
          zeppanItems: zeppanItems.value,
          isTandoku: false,
          tandokuSyosiInfo: undefined,
          onExecute: confirmedAlert,
          onClose: closeAlertModal
        }, null, 8, ["zeppanItems"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hikitsugi_list.value, (hikitsugi, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  onClick: ($event: any) => (selectHikitsugi(hikitsugi)),
                  class: _normalizeClass(["OrderFormMulti_SelectArea_Item", { OrderFormMulti_IsSelected: hikitsugi.selectFlg }])
                }, _toDisplayString(hikitsugi.name), 11, _hoisted_7))
              }), 128))
            ])
          ]),
          _createVNode(SelectBarSingle, {
            style: {"margin-bottom":"0"},
            selectBarList_props: selectBar_hold.value,
            onUpdateSelectValue: updateSelectHold
          }, null, 8, ["selectBarList_props"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              class: _normalizeClass(["OrderFormMulti_Button GreenSmall", {
                disabled_btn: isDownloading.value,
                Move_With_Enter: !isDownloading.value,
              }]),
              onClick: toggleDownloadSelectBox,
              disabled: isDownloading.value
            }, [
              (!isDownloading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "download",
                    style: {"display":"inline-block"}
                  }))
                : _createCommentVNode("", true),
              (isDownloading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              _createTextVNode(" ダウンロード ")
            ], 10, _hoisted_10),
            (downloadSelectBoxFlg.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (!isDownloading.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (getExcelData('normal'))),
                        class: "OrderFormMulti_Download_Option Move_With_Enter Move_With_Enter"
                      }, _hoisted_14))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)),
                  (!isDownloading.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (getExcelData('simple'))),
                        class: "OrderFormMulti_Download_Option Move_With_Enter"
                      }, _hoisted_19))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                ]))
              : _createCommentVNode("", true)
          ])), [
            [_unref(vClickOutside), downloadOutsideClick]
          ]),
          _createElementVNode("input", {
            onChange: uploadFile,
            onClick: resetFile,
            type: "file",
            ref_key: "inputFile",
            ref: inputFile,
            accept: ".xlsx",
            style: {"display":"none"}
          }, null, 544),
          _createElementVNode("button", {
            onClick: onClickUpload,
            class: _normalizeClass(["OrderFormMulti_Button GreenSmall", {
              disabled_btn: isUploading.value,
              Move_With_Enter: !isUploading.value,
            }]),
            disabled: isUploading.value
          }, [
            (!isUploading.value)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "upload",
                  style: {"display":"inline-block"}
                }))
              : _createCommentVNode("", true),
            (isUploading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24))
              : _createCommentVNode("", true),
            _hoisted_25
          ], 10, _hoisted_23),
          _createElementVNode("button", {
            onClick: deleteAllMultiOrderList,
            class: "OrderFormMulti_Button GreenSmall Move_With_Enter"
          }, " すべて削除 ")
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("table", {
          ref_key: "scrollTable",
          ref: scrollTable,
          class: "OrderFormMulti_Table"
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _createElementVNode("th", _hoisted_35, [
                _createTextVNode(" 短冊ﾃﾞｰﾀ "),
                (showAllTanzakuEditBtn.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: clickAllTanzakuEdit,
                      class: "OrderFormMulti_Button GreenSmall Move_With_Enter",
                      style: {"margin-left":"5px"}
                    }, " 一括編集 "))
                  : (_openBlock(), _createElementBlock("button", _hoisted_36, " 一括編集 "))
              ]),
              _hoisted_37
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(multiOrder_list.value, (order, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_38, [
                  _createTextVNode(_toDisplayString(order.meisaiNo) + " ", 1),
                  _hoisted_39,
                  (order.isHold)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                        _createVNode(BadgeHold)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", {
                  class: _normalizeClass(["OrderFormMulti_Table_SyotenInfo OrderFormMulti_Table_ValignTop", {
                  isSelected:
                    hikitsugi_list.value.find(
                      (hikitsugi) => hikitsugi.name === '取次'
                    )?.isActiveTakeOverFlg ||
                    hikitsugi_list.value.find(
                      (hikitsugi) => hikitsugi.name === '書店'
                    )?.isActiveTakeOverFlg,
                }])
                }, [
                  _createElementVNode("select", {
                    value: order.toritugiCd,
                    onChange: ($event: any) => (inputToritugi($event, index)),
                    class: _normalizeClass(["Move_With_Enter", {
                    td_error:
                      hasCartError.value &&
                      judgeCartError(index, 'toritugi') !== null,
                  }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toritugiList.value, (option, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: option.toritugiCd,
                        key: index
                      }, _toDisplayString(option.toritugiMei), 9, _hoisted_42))
                    }), 128))
                  ], 42, _hoisted_41),
                  (hasCartError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(judgeCartError(index, "toritugi")), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("td", {
                  class: _normalizeClass(["OrderFormMulti_Table_Jyoken OrderFormMulti_Table_ValignTop", {
                  isSelected: hikitsugi_list.value.find(
                    (hikitsugi) => hikitsugi.name === '書店'
                  )?.isActiveTakeOverFlg,
                }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["OrderFormMulti_Inputdblclick Move_With_Enter", {
                    td_error:
                      hasCartError.value && judgeCartError(index, 'syoten') !== null,
                  }]),
                    type: "text",
                    placeholder: "書店コード",
                    "onUpdate:modelValue": ($event: any) => ((order.toritugisyotenCd) = $event),
                    onDblclick: ($event: any) => (openSearchSyotenModal(index)),
                    onFocus: ($event: any) => (focusSyotenCd($event, index)),
                    onChange: searchSyoten,
                    onkeydown: "return event.keyCode !== 69"
                  }, null, 42, _hoisted_44), [
                    [_vModelText, order.toritugisyotenCd]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "OrderFormMulti_Input input_adjust Move_With_Enter",
                    type: "text",
                    placeholder: "番線",
                    "onUpdate:modelValue": ($event: any) => ((order.bansen) = $event)
                  }, null, 8, _hoisted_45), [
                    [_vModelText, order.bansen]
                  ]),
                  _hoisted_46,
                  (hasCartError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(judgeCartError(index, "syoten")), 1))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    class: "OrderFormMulti_Input input_full input_disabled",
                    type: "text",
                    placeholder: "書店名",
                    "onUpdate:modelValue": ($event: any) => ((order.toritugisyotenMei) = $event),
                    disabled: ""
                  }, null, 8, _hoisted_48), [
                    [_vModelText, order.toritugisyotenMei]
                  ])
                ], 2),
                _createElementVNode("td", {
                  class: _normalizeClass(["OrderFormMulti_Table_SyotenInfo OrderFormMulti_Table_ValignTop", {
                  isSelected: hikitsugi_list.value.find(
                    (hikitsugi) => hikitsugi.name === '書誌'
                  )?.isActiveTakeOverFlg,
                }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["OrderFormMulti_Inputdblclick_syosicd Move_With_Enter", {
                    isSelected: hikitsugi_list.value.find(
                      (hikitsugi) => hikitsugi.name === '書誌'
                    )?.isActiveTakeOverFlg,
                    td_error:
                      hasCartError.value && judgeCartError(index, 'syosi') !== null,
                  }]),
                    type: "text",
                    placeholder: "商品コード",
                    "onUpdate:modelValue": ($event: any) => ((order.searchSyosiCord) = $event),
                    onDblclick: ($event: any) => (openSearchSyosiModal(index)),
                    onFocus: ($event: any) => (focusSyosiCd(index)),
                    onChange: searchSyosi
                  }, null, 42, _hoisted_49), [
                    [_vModelText, order.searchSyosiCord]
                  ]),
                  _createElementVNode("p", _hoisted_50, _toDisplayString(order.zsNameDisplay) + " / " + _toDisplayString(order.cutting), 1)
                ], 2),
                _createElementVNode("td", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["OrderFormMulti_Input input_disabled", {
                      isSelected: hikitsugi_list.value.find(
                        (hikitsugi) => hikitsugi.name === '書誌'
                      )?.isActiveTakeOverFlg,
                    }]),
                      placeholder: "本体価格",
                      "onUpdate:modelValue": ($event: any) => ((order.hontaiPrice) = $event),
                      disabled: ""
                    }, null, 10, _hoisted_53), [
                      [_vModelText, order.hontaiPrice]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((order.salesName) = $event),
                      class: _normalizeClass(["Move_With_Enter", {
                      isSelected: hikitsugi_list.value.find(
                        (hikitsugi) => hikitsugi.name === '依頼者'
                      )?.isActiveTakeOverFlg,
                    }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salesList.value, (option, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: option.salesCd,
                          key: index
                        }, _toDisplayString(option.salesName), 9, _hoisted_55))
                      }), 128))
                    ], 10, _hoisted_54), [
                      [_vModelSelect, order.salesName]
                    ])
                  ]),
                  (hasCartError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(judgeCartError(index, "syosi")), 1))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["OrderFormMulti_Input input_full input_disabled", {
                    isSelected: hikitsugi_list.value.find(
                      (hikitsugi) => hikitsugi.name === '書誌'
                    )?.isActiveTakeOverFlg,
                  }]),
                    type: "text",
                    placeholder: "書名",
                    "onUpdate:modelValue": ($event: any) => ((order.syosiMei) = $event),
                    disabled: ""
                  }, null, 10, _hoisted_57), [
                    [_vModelText, order.syosiMei]
                  ])
                ]),
                _createElementVNode("td", {
                  class: _normalizeClass({ isSelected: highlightHold.value })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((order.isHold) = $event)
                  }, null, 8, _hoisted_58), [
                    [_vModelCheckbox, order.isHold]
                  ])
                ], 2),
                _createElementVNode("td", _hoisted_59, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "OrderFormMulti_Input input_disabled",
                    "onUpdate:modelValue": ($event: any) => ((order.availableAmount) = $event),
                    disabled: ""
                  }, null, 8, _hoisted_60), [
                    [_vModelText, order.availableAmount]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["OrderFormMulti_Input Move_With_Enter", {
                    isSelected: hikitsugi_list.value.find(
                      (hikitsugi) => hikitsugi.name === '冊数'
                    )?.isActiveTakeOverFlg,
                    td_error:
                      hasCartError.value &&
                      judgeCartError(index, 'quantity') !== null,
                  }]),
                    "onUpdate:modelValue": ($event: any) => ((order.quantity) = $event),
                    onFocus: ($event: any) => (focusQuantity($event, index)),
                    onChange: ($event: any) => (validateQuantity($event, index)),
                    onBlur: ($event: any) => (blurQuantity($event, index))
                  }, null, 42, _hoisted_61), [
                    [_vModelText, order.quantity]
                  ]),
                  (hasCartError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(judgeCartError(index, "quantity")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_63, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "OrderFormMulti_Input input_disabled",
                    "onUpdate:modelValue": ($event: any) => ((order.holdSum) = $event),
                    disabled: ""
                  }, null, 8, _hoisted_64), [
                    [_vModelText, order.holdSum]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "OrderFormMulti_Input input_disabled",
                    "onUpdate:modelValue": ($event: any) => ((order.shinagireHoryuSuu) = $event),
                    disabled: ""
                  }, null, 8, _hoisted_65), [
                    [_vModelText, order.shinagireHoryuSuu]
                  ])
                ]),
                _createElementVNode("td", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((order.selectFlg) = $event),
                      onChange: checkSelectFlg,
                      class: "Move_With_Enter"
                    }, null, 40, _hoisted_68), [
                      [_vModelCheckbox, order.selectFlg]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "Tanzaku_Input",
                      class: "OrderFormMulti_Input input_full Move_With_Enter",
                      "onUpdate:modelValue": ($event: any) => ((order.tanzaku) = $event)
                    }, null, 8, _hoisted_69), [
                      [_vModelText, order.tanzaku]
                    ])
                  ]),
                  (isValidTanzaku.value(order.tanzaku))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_70, _hoisted_72))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", {
                  onClick: ($event: any) => (deleteMultiOrderList(index)),
                  class: "OrderFormMulti_Table_Delete OrderFormMulti_Table_ValignMid"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "OrderFormMulti_Table_Icon Move_With_Enter",
                    icon: "trash-can"
                  })
                ], 8, _hoisted_73)
              ]))
            }), 128))
          ])
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("p", _hoisted_75, "合計冊数：" + _toDisplayString(totalNumberOfBooks.value) + "冊", 1),
        _createElementVNode("button", {
          onClick: addMultiOrderList,
          class: "OrderFormMulti_Button GreenRev Move_With_Enter"
        }, " + 明細追加 "),
        _createElementVNode("button", {
          onClick: addOrderToCart,
          class: _normalizeClass(["OrderFormMulti_Button Green Move_With_Enter", {
            disabled_btn: JSON.stringify(multiOrder_list.value) === initialData.value,
          }])
        }, " カート追加 ", 2)
      ])
    ])
  ], 2))
}
}

})